import { z } from "zod";

export const obraSchema = z.object({
	name: z.string().trim().min(1, "Informe o nome da obra"),
	description: z.string().optional(),
	startDate: z.string().optional(),
	expectedEndDate: z.string().optional(),
});

export type ObraFormValues = z.infer<typeof obraSchema>;
